import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import MainBoard from './MainBoard';

import {
    getScoreData,
    getProjectsData,
    getReSurveyData,
    getDemographics,
    getBenchmarks,
    updateFilters,
    resetReSurveyDataFetched,
    getBuData,
    resetBuDataFetched,
    getPptData,
    toggleCreateTheme,
    setPracticeDisplay,
    getClientEngagementData,
    getSinglePastReport,
    getTargetScoreData,
    updateTargetSettingBm,
    getCohesionData,
} from '../actions';

import { updateBuFilters, getReport, getRawPptData, updateEntireOrganizationComparison } from '../../Reports/actions';
import { selectBuFilters, selectReportError, selectBuScorecardEntireOrganization } from '../../Reports/selector';
import { getDefaultSettings } from '../../Login/selector';

import {
    selectScoreData,
    selectScoreDataFetched,
    selectApiParams,
    selectApiCount,
    selectProjects,
    selectProjectsFetched,
    selectReSurveyData,
    selectReSurveyDataFetched,
    getErrorInfo,
    selectFilters,
    selectFiltersApplied,
    selectBuData,
    selectBuDataFetched,
    selectCurrentTheme,
    selectClientEngagementData,
    selectClientEngagementFetched,
    selectPastReport,
    selectCohesionDemographic,
    selectLocalPractice,
    selectTargetScoreData,
    selectTargetScoreDataFetched,
    selectTargetBenchmarks,
    selectTargetBm,
    selectFootnoteList,
    selectCohesionScore,
    selectCohesionDataFetched,
} from '../selector';

const stateToProps = createStructuredSelector({
    scoreData: selectScoreData(),
    scoreDataFetched: selectScoreDataFetched(),
    apiParams: selectApiParams(),
    apiLoadingCount: selectApiCount(),
    projects: selectProjects(),
    projectsFetched: selectProjectsFetched(),
    reSurveyData: selectReSurveyData(),
    reSurveyDataFetched: selectReSurveyDataFetched(),
    errorInfo: getErrorInfo(),
    filters: selectFilters(),
    activeResetFilter: selectFiltersApplied(),
    buData: selectBuData(),
    buDataFetched: selectBuDataFetched(),
    buFilters: selectBuFilters(),
    isEntireOrganizationSelected: selectBuScorecardEntireOrganization(),
    currentTheme: selectCurrentTheme(),
    defaultSettings: getDefaultSettings(),
    clientEngagement: selectClientEngagementData(),
    clientEngagementFetched: selectClientEngagementFetched(),
    reportError: selectReportError(),
    singlePastReport: selectPastReport(),
    cohesionDemographic: selectCohesionDemographic(),
    localPractice: selectLocalPractice(),
    targetScoreData: selectTargetScoreData(),
    targetScoreDataFetched: selectTargetScoreDataFetched(),
    targetBenchmarks: selectTargetBenchmarks(),
    targetBm: selectTargetBm(),
    footnoteList: selectFootnoteList(),
    cohesionScore: selectCohesionScore(),
    cohesionDataFetched: selectCohesionDataFetched(),
});

const dispatchToProps = {
    getScoreData,
    getProjectsData,
    getReSurveyData,
    getDemographics,
    getBenchmarks,
    updateFilters,
    resetReSurveyDataFetched,
    getBuData,
    resetBuDataFetched,
    updateBuFilters,
    updateEntireOrganizationComparison,
    getPptData,
    toggleCreateTheme,
    setPracticeDisplay,
    getClientEngagementData,
    getReport,
    getRawPptData,
    getSinglePastReport,
    getTargetScoreData,
    updateTargetSettingBm,
    getCohesionData,
};

export default connect(stateToProps, dispatchToProps)(MainBoard);
